import { createContext, useContext, useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { flushQueue } from "@/lib/offline";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, object = auth, false = not auth

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const expire = () => setUser(false);
    window.addEventListener("madlo:session-expiree", expire);
    // Rafraîchissement préventif toutes les 10 min (jeton d'accès : 15 min) tant que l'onglet est ouvert
    const t = setInterval(() => { if (navigator.onLine) api.post("/auth/refresh").catch(() => {}); }, 10 * 60 * 1000);
    return () => { window.removeEventListener("madlo:session-expiree", expire); clearInterval(t); };
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    flushQueue();
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("Déconnexion serveur impossible (session locale effacée)", e?.message); }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { apiError };
